import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';

import { SonarV3SortDirection, SortByOption } from '@sonar-software/sonar-ts-types';

export const v3FlowSortOptions: SortByOption[] = [
	{
		direction: SonarV3SortDirection.Ascending,
		key: 'name',
		label: COPY_SPECIFIC.NAME
	},
	{
		direction: SonarV3SortDirection.Descending,
		key: 'isActive',
		label: COPY_SPECIFIC.ACTIVE
	},
	{
		direction: SonarV3SortDirection.Descending,
		key: 'versionNumber',
		label: COPY_SPECIFIC.VERSION
	}
];
